


























import QrcodeVue from "qrcode.vue";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component({
  name: "integralGoodsPreviewDialog",
  components: {
    QrcodeVue,
  },
})
export default class extends Vue {
  @Prop() goodsId!: number;
  dialogVisible: boolean = false;
  qrcodeSrc: string = "";
  openDialog() {
    if (!this.goodsId) {
      return false;
    }
    this.qrcodeSrc = `${process.env.VUE_APP_H5_HOST}/#/student/shop_details?goods_id=${this.goodsId}`;
    this.dialogVisible = true;
  }
  handleClose() {
    this.dialogVisible = false;
  }
}
